<template>
  <div class="col-3-center">
    <h1>Pressemitteilungen</h1>
    <p>Das Räumliche Leitbild soll einerseits die Grundlage für die Aktualisierung des Flächennutzungsplanes bilden, andererseits die grundsätzlichen städtebaulichen und strukturellen Entwicklungsperspektiven der Stadt Dachau abbilden.</p>
    <p>In der Etappe 1 des Projektes wurde eine umfangreiche Bestands­analyse und Bewertung der Ausgangssituation vorgenommen.</p>
    <p>Verschiedene Module der Mitwirkung markieren den im Zeitraum ­Oktober 2018 – Januar 2019 geführten intensiven Dialog mit Bevölkerung und Interessensgruppen:</p>
    <ul class="unordered-list">
      <li>In 17 persönlich geführten Fach- und Expertengesprächen (u.a. Bund Naturschutz, Jugendrat, Sozialverbände, Mieterverein, IHK, ­Einzelhandel u.v.m.) wurden insbesondere die Ausgangssituation ­(Stärken-Schwächen-Profil) und die Perspektiven der Großen Kreisstadt Dachau (Chancen-Risiken-Bewertung) besprochen.</li>
      <li>484 User haben die interaktive Karte auf ­­www.dachaudenktweiter.de genutzt, um über 2.200 Vorschläge, Ideen, Kritikpunkte sowie lobende Worte direkt im Stadtgebiet zu markieren. Über 50% der Eintragungen entfallen auf den Bereich Mobilität.</li>
      <li>75 gezeichnete und textlich formulierte Bilder der Stadt Dachau des Ist-Zustandes sowie des Soll-Zustandes im Postkarten-Format wurden ausgewertet.</li>
      <li>Regelmäßige Abstimmungen mit der Stadtplanung, Projektleiterin Frau Jungwirth, Herrn Reinhold, den Amtsleitern und OB Hartmann, um auch aktuellen Themen und Planungen in das Projekt einfließen zu lassen (z.B. Nachnutzung MD-Areal).</li>
    </ul>
    <hr />
    <div v-for="(file, i) in files" :key="i">
      <h2>{{ file.title }}</h2>
      <a :href="path + file.name" target="_blank" :download="file.name">{{ file.name }}</a>
      <hr />
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "Pressemitteilungen"
  },
  data() {
    return {
      path: "/static/dokumente/",
      files: [
        {
          title: "Pressemitteilung 1",
          name: "pressemitteilung_1.pdf"
        },
        {
          title: "Pressemitteilung 2",
          name: "pressemitteilung_2.pdf"
        },
        {
          title: "Pressemitteilung 3 - Allgemeines",
          name: "pressemitteilung_3_allgemeines.pdf"
        },
        {
          title: "Pressemitteilung 4 -  Programm",
          name: "pressemitteilung_4_programm.pdf"
        },
        {
          title: "Pressemitteilung 5 - Vorträge",
          name: "pressemitteilung_5_vortraege.pdf"
        },
        {
          title: "Pressemitteilung 6 - Parklet(mit Ideen-Baum)",
          name: "pressemitteilung_6_parklet.pdf"
        }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.card {
  display: flex;
  // justify-content: center;
  align-items: center;
  a {
    margin-bottom: 10px !important;
  }
}
h2 {
  color: black !important;
}

.unordered-list li {
  margin: 10px 0;
  line-height: 20px;
}
</style>
